document.addEventListener('DOMContentLoaded', function() {
  const videoButtons = document.querySelectorAll('[data-video-section]');
  videoButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const sectionId = this.getAttribute('data-video-section');
      const image = document.querySelector(`#image-${sectionId}`);
      const video = document.querySelector(`#video-${sectionId}`);
      const section = document.querySelector(`#shopify-section-${sectionId}`);
      const prose = document.querySelector(`#shopify-section-${sectionId} .prose`);
      
      if (image && video && prose) {
        image.style.display = 'none';
        prose.style.display = 'none';
        if (section) {
          console.log('Increase opacity of video player');
          section.style.setProperty("--content-over-media-overlay", "0");
        }
        video.style.display = 'block';
        video.play();
      } else {
        console.error('Elements not found:', { image, video, prose });
      }
    });
  });
});